export default "__VITE_ASSET__BMiIQBE6__"